
import { Component, Vue, Prop } from "vue-property-decorator"
import { CircularLoader, PullRefresh } from "@coredination/components"
import { navbar, NavbarOption } from "@/components/NavbarOptions.vue"

import TransportDocumentContactEditDialog from "./TransportDocumentContactEditDialog.vue"
import TransportDocumentWasteItem from "./TransportDocumentWasteItem.vue"

import TransportDocumentTemplate from "@/graphql/transportdocument/transportdocumenttemplate.graphql"
import SaveTransportDocument from "@/graphql/transportdocument/savetransportdocument.graphql"
import DeleteTransportDocument from "@/graphql/transportdocument/deletetransportdocument.graphql"

@Component({
    apollo: {
        transportDocument: {
            query: TransportDocumentTemplate,
            variables() {
                return {
                    jobUuid: this.$route.params.jobUuid,
                    wasteItemIds: this.$route.params.wasteItemIds
                }
            },
            skip() {
                return this.transportDocumentProp || !this.$route.params.jobUuid || !this.$route.params.wasteItemIds
            },
            update(data: any) {
                return data.template
            }
        }
    },
    components: {
        CircularLoader,
        PullRefresh,
        TransportDocumentContactEditDialog,
        TransportDocumentWasteItem,
        AreYouSureDialog: () => import("@/components/dialogs/AreYouSureDialog.vue"),
    }
})
export default class TransportDocumentEdit extends Vue {

    @Prop({ default: false })
    new!: boolean
    @Prop({ default: null })
    transportDocumentProp?: any


    saving: boolean = false
    transportDocument: any
    jobUuid: null | string = null
    wasteItemIds: null | Number[] = null

    selectedContact: any = null
    showAreYouSure: boolean = false

    contactRefreshKey: number = 0

    get navbarOptions(): NavbarOption[] {
        var options = []
        if (this.transportDocument?.id) {
            options.push({
                title: this.$t("delete"),
                action: () => this.showAreYouSure = true
            })
        }
        return options
    }

    mounted() {
        navbar?.setOptions(this.navbarOptions)
    }

    created() {
        if (!this.transportDocumentProp) {
            this.jobUuid = this.$route.params.jobUuid
            this.wasteItemIds = this.$route.params.wasteItemIds?.split(",").map(Number)
        } else this.transportDocument = this.transportDocumentProp
    }

    save() {
        this.saving = true
        var input = this.getInputObj()
        return this.$apollo
            .mutate({
                mutation: SaveTransportDocument,
                variables: {
                    input: input
                },
                update(proxy, response) {
                    const hackProxy = proxy as any
                    Object.keys(hackProxy.data.data).forEach((key) => {
                        if (key.match(/(myJobs|myWorkStats|JobResource|JobListItem|TransportDocument)/)) {
                            hackProxy.data.delete(key)
                        }
                    })
                }
            })
            .then(async (response) => {
                Object.assign(this.transportDocument, response.data.save)
                if (this.$route.path.includes("new"))
                    this.$router.replace(`/transportdocument/${this.transportDocument.uuid}`)
            })
            .catch((error) => {
                console.error(error)
            })
            .finally(() => {
                this.saving = false
            })
    }

    remove() {
        this.saving = true
        this.$apollo.mutate({
            mutation: DeleteTransportDocument,
            variables: { uuid: this.transportDocument.uuid }
        }).then(() => {
            this.$router.go(-1) // back to job
        }).catch((error: any) => {
            console.error(error)
        }).finally(() => {
            this.saving = false
        })
    }

    getInputObj() {
        var copy = JSON.parse(JSON.stringify(this.transportDocument))
        delete copy.__typename
        
        delete copy.dispatcher.__typename
        if (copy.dispatcher.signature)
            delete copy.dispatcher.signature.__typename

        delete copy.transporter.__typename
        if (copy.transporter.signature)
            delete copy.transporter.signature.__typename

        delete copy.recipient.__typename
        if (copy.recipient.signature)
            delete copy.recipient.signature.__typename

        copy.wasteItems.forEach((item: any) => {
            delete item.__typename
        })

        return copy
    }

    translateUnit(unit: string) {
        return this.$t(`unit_${unit}`)
    }

    translateContactType(type: string) {
        return type && this.$t(`transportDocument_contactType_${type}`)
    }

    icon(contact: any) {
        return this.contactSigned(contact) ? "check_circle" : "edit"
    }

    contactSigned(contact: any) {
        return contact?.signature?.data
    }

    openSignDialog(contact: any) {
        if (!contact.signature)
            contact.signature = {}
        this.contactRefreshKey++
        this.$nextTick(() => {
            this.selectedContact = contact
            ;(this.$refs.contactDialog as any).showDialog(this.selectedContact)
        })
    }

    clsoeDialog() {
        this.selectedContact = null
    }

    preview() {
        this.$router.push(`/transportdocument/${this.transportDocument.uuid}/preview`)
        return false
    }

    get loading() {
        return this.$apollo.queries.transportDocument.loading
    }

    get isTemplate() {
        return this.transportDocument?.id
    }

    get signed() {
        return this.contactSigned(this.transportDocument.dispatcher) &&
            this.contactSigned(this.transportDocument.transporter) &&
            this.contactSigned(this.transportDocument.recipient)
    }
}
